<script lang="ts" setup>
import Textarea from 'primevue/textarea'
import InputLabel from '@/components/inputs/InputLabel.vue'
import InputError from '@/components/inputs/InputError.vue'

import { useField } from 'vee-validate'

const props = defineProps<{
  id: string
  label: string
  inputName: string
  disabled?: boolean
  viewOnly?: boolean
  placeholder?: string
}>()

const { value, errorMessage } = useField<string>(() => props.inputName)
</script>

<template>
  <div class="flex flex-col">
    <InputLabel :forInput="id">{{ label }}</InputLabel>
    <p class="py-1 font-medium text-[15px]" v-if="viewOnly">
      {{ value }}
    </p>

    <Textarea
    v-else
      :id="id"
      :disabled="disabled"
      :placeholder="placeholder"
      :invalid="!!errorMessage"
      v-model="value"
      rows="5"
      cols="30"
    />

    <InputError v-show="errorMessage">
      {{ errorMessage }}
    </InputError>
  </div>
</template>
<style></style>
